
import { CardDataImpl } from '@/interface/config.interface';
import { textMaxStr, Uuid } from '@/lib';
import { Tooltip } from 'ant-design-vue';
import {
  defineComponent, PropType,
} from 'vue';

export default defineComponent({
  name: '案例卡片',
  components: {
    aTooltip: Tooltip,
  },
  props: {
    /** 卡片数据 */
    cardData: {
      type: Object as PropType<Uuid<CardDataImpl>>,
      required: true,
    },
    /** 排列方式 */
    layout: {
      type: String as PropType<'row'|'col'>,
      required: true,
    },
  },
  setup() {
    return {
      textMaxStr,
    };
  },
});
